import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { PTPView } from "@portal/types/entities/ptp";
import { PTPDefaultKeys } from "./type";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];

export const ptpFilterGroups = [
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];

export const ptpDefaultKeys: PTPDefaultKeys[] = [
  "from_date",
  "credit_date_range",
  "to_date",
];

export const ptpViewOptions: GenericRadioOptions<PTPView> = [
  {
    label: "All",
    value: "ALL",
  },
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
];

export const ptpStatusOptions = [
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
];
